import { form } from 'svelte-forms';
import type { Readable, Writable } from 'svelte/store';
import { derived, get } from 'svelte/store';
import type { Database } from './supabase';

export type Field<T> = {
	name: string;
	value: T;
	valid: boolean;
	invalid: boolean;
	dirty: boolean;
	errors: string[];
};

export function customForm(...fields: (Writable<Field<any>> | Readable<Field<any>>)[]) {
	const internalForm = form(...fields);
	const internalState = derived([internalForm], ([$internalForm]) => ({
		isAllDirty: fields.every((f) => get(f).dirty),
		...$internalForm
	}));

	return {
		...internalState,
		internalForm
	};
}

export interface SignUpForm1Data {
	email: string;
	password: string;
	username: string;
	newsletter_accepted: boolean;
}

export type ProfileProperty = keyof Database['public']['Tables']['profiles']['Row'];

export type SignUpStepData = {
	step: number;
	field: ProfileProperty;
	options: {
		id: string;
		title: string;
	}[];
	additionalClass?: string;
};

export type SignUpStepOption = {
	id: string;
	title: string;
};